import { ApiRequestError } from './log-sanitiser';
import { MAX_CHARS } from './telemetry-context';

/**
 * Telemetry for the submit and prematch calls (DEV-7892): what came back, and
 * why a call failed. Pure functions, so they test without TestBed.
 */

/** What a 200 from send-request carried: a lead token, a saved failed lead, or neither. */
export function submitOutcome( response: unknown ): 'token' | 'saved_failed_lead' | 'no_token' {

	const body = ( response ?? {} ) as { token?: unknown, saved_failed_lead?: unknown };

	if( body.saved_failed_lead === true ) {
		return 'saved_failed_lead';
	}

	return typeof body.token === 'string' && body.token.length > 0 ? 'token' : 'no_token';
}

/** Why a request failed and how long the visitor waited. Logged as is: logdb is our own store. */
export function failureDetails( error: unknown, elapsedMs: number ): Record<string, string | number> {

	const elapsed = Math.round( elapsedMs );

	if( error instanceof ApiRequestError ) {
		return { failure: error.failure, endpoint: error.endpoint, elapsed_ms: elapsed };
	}

	let failure = 'unknown';
	try {
		failure = String( error ).slice( 0, MAX_CHARS );
	} catch {
		// An error whose toString throws: describe it as unknown.
	}

	return { failure, elapsed_ms: elapsed };
}

/** The start of a response body, as sent, to recognise an HTML error page or an empty reply. */
export function responseStart( body: unknown ): string {

	if( body === undefined || body === null ) {
		return '';
	}

	try {

		const text = typeof body === 'string' ? body : JSON.stringify( body );
		return text.slice( 0, MAX_CHARS );

	} catch {
		// A body JSON cannot serialise (e.g. circular): nothing to show.
		return '';
	}
}

/** `prematch_ms` for a prematch that ran; the control starts at 0, which means none ran. */
export function prematchTiming( duration: unknown ): { prematch_ms: number } | undefined {

	return typeof duration === 'number' && duration > 0 ? { prematch_ms: Math.round( duration ) } : undefined;
}
